// LocalStorage helpers for recent courses. Only stores public course
// metadata (name, par array, stroke-index array) — no personal or sensitive
// data, so localStorage is appropriate here.
const KEY = "fs.recent-courses";
const MAX = 5;

export function loadRecentCourses() {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return [];
        const arr = JSON.parse(raw);
        if (!Array.isArray(arr)) return [];
        return arr.filter(c => c && typeof c === 'object' && typeof c.courseLabel === 'string').slice(0, MAX);
    } catch (err) {
        // Quota / private-mode / corrupt JSON — degrade gracefully.
        console.warn("recentCourses.load failed:", err);
        return [];
    }
}

export function findRecentCourse(label) {
    if (!label) return null;
    const all = loadRecentCourses();
    return all.find((c) => c.courseLabel === label) || null;
}

export function saveRecentCourse(entry) {
    if (!entry?.courseLabel) return;
    try {
        const cur = loadRecentCourses();
        const dedup = cur.filter((c) => c.courseLabel !== entry.courseLabel);
        const next = [{ ...entry, savedAt: Date.now() }, ...dedup].slice(0, MAX);
        localStorage.setItem(KEY, JSON.stringify(next));
    } catch (err) {
        console.warn("recentCourses.save failed:", err);
    }
}

export function removeRecentCourse(label) {
    try {
        const cur = loadRecentCourses();
        localStorage.setItem(
            KEY,
            JSON.stringify(cur.filter((c) => c.courseLabel !== label)),
        );
    } catch (err) {
        console.warn("recentCourses.remove failed:", err);
    }
}
